import { MARGIN, MONTH, VEHICLE } from "../../../data/data";
import { numberWithCommas } from "../../../utils/customFunctions";

//#region NEW TOURS
// FINAL RATE (USD)
export function getNewTotalRateUSD(data, info, TAGS, hasCoordinates){
    let usdConversion = Number.parseFloat(info?.filterSharedData(TAGS.USD_CONVERSION));
    usdConversion = usdConversion === 0 ? 1 : usdConversion;
    
    const usd = (getNewTourTotalRateLKR(data, info, TAGS, hasCoordinates) / usdConversion).toFixed(2);
    
    return numberWithCommas(usd);
}

// BATTA
export function getNewTourBatta(info, battaTag){
    return Number.parseFloat(info?.filterSharedData(battaTag));
}

// TOTAL BATTA RATE
export function getNewTourTotalBatta(data, info, battaTag){
    let rate = 0;

    // Assumes it has batta
    const totalDays = data?.days ?? 1;
    rate +=  getNewTourBatta(info, battaTag) * totalDays;
    
    return rate;
}

// DISTANCE OFFSET PER 7 DAYS
export function getAdditionalNewTourDayBasedDistance(data, info, TAGS, hasCoordinates){
    // Manual distance
    if(!hasCoordinates){
        return 0;
    }
    
    if(Number.parseInt(data?.days) >= 7){
        return Number.parseFloat(info?.filterSharedData(TAGS.KM_GREATER_7)); 
    }
    else{
        return Number.parseFloat(info?.filterSharedData(TAGS.KM_LESS_EQUAL_7));
    }
}

// TOTAL DISTANCE AFTER 7 DAYS OFFSET
export function getNewTourDrivingKm(data, info, TAGS, hasCoordinates){
    let totalKm = Number.parseFloat(data?.distance);
    totalKm += getAdditionalNewTourDayBasedDistance(data, info, TAGS, hasCoordinates);

    return totalKm;
}

// MINIMUM KM PER DAY TO COVER
export function getNewTourMinimumKm(info, TAGS){
    return Number.parseFloat(info?.filterSharedData(TAGS.MIN_KM_PER_DAY));
}

// MINIMUM KM PER TOUR TO COVER
export function getNewTourMinimumKmToCover(data, info, TAGS){
    let kmPerDay = getNewTourMinimumKm(info, TAGS);
    return data?.days * kmPerDay;
}

// FINAL DISTANCE
export function getNewTourFinalKm(data, info, TAGS, hasCoordinates){
    const totalKm = getNewTourDrivingKm(data, info, TAGS, hasCoordinates);
    const minKm = getNewTourMinimumKmToCover(data, info, TAGS);

    if(totalKm < minKm){
        return minKm;
    }

    return totalKm;
}

// ROUND OF THE FINAL KM
export function getNewTourRoundedKmOffset(data, info, TAGS, hasCoordinates){
    let roundingKmDigit = getNewTourFinalKm(data, info, TAGS, hasCoordinates);

    if(roundingKmDigit > 100){
        roundingKmDigit = roundingKmDigit % 100;
    }

    let roundKm = 0;

    if(roundingKmDigit <= 20){
        roundKm = -roundingKmDigit;
    }
    else if(roundingKmDigit <= 80){
        roundKm = 50 - roundingKmDigit;
    }
    else{
        roundKm = 100 - roundingKmDigit;
    }

    return roundKm;
}
export function getNewTourRoundedKm(data, info, TAGS, hasCoordinates){
    let finalKm = getNewTourFinalKm(data, info, TAGS, hasCoordinates);

    finalKm += getNewTourRoundedKmOffset(data, info, TAGS, hasCoordinates);

    return finalKm;
}

// USD CONVERSION RATE
export function getNewTourUSDConversionRate(info, TAGS){
    return Number.parseFloat(info?.filterSharedData(TAGS.USD_CONVERSION));
}

// ADDITIONAL KM
export function getNewTourAdditionalKm(data, info, TAGS, hasCoordinates){
    return (getNewTourFinalKm(data, info, TAGS, hasCoordinates) - getNewTourDrivingKm(data, info, TAGS, hasCoordinates)).toFixed(2);
}

// ACTUAL RATE WITHOUT BATTA
export function getNewTourActualRateWithoutBatta(data, info, TAGS, hasCoordinates){
    let rate = getNewTourRoundedKm(data, info, TAGS, hasCoordinates) * Number.parseFloat(data?.perKm);
    return numberWithCommas(rate.toFixed(2));
}

// GET TOTAL
export function getNewTourTotalRateLKR(data, info, TAGS, hasCoordinates){
    let rate = getNewTourRoundedKm(data, info, TAGS, hasCoordinates) * Number.parseFloat(data?.perKm);

    rate += getNewTourTotalBatta(data, info, TAGS.BATTA);

    const usdConversion = getNewTourUSDConversionRate(info, TAGS);
    rate += getSeasonRate(data, usdConversion) + getMarginLKR(data, usdConversion);

    return rate;
}
//#endregion

//#region EXISTING TOURS
// FINAL RATE (USD)
export function getExistingTotalRateUSD(data, hasCoordinates){
    let usdConversion = Number.parseFloat(data.usdConversion);
    usdConversion = usdConversion === 0 ? 1 : usdConversion;

    const usd = (getExistingTourTotalRateLKR(data, hasCoordinates) / usdConversion).toFixed(2);
    
    return numberWithCommas(usd);
}

// BATTA
export function getExistingTourBatta(data){
    return data.battaAmount;
}

// TOTAL BATTA RATE
export function getExistingTourTotalBatta(data){
    let rate = 0;

    // Assumes it has batta
    const totalDays = data?.days ?? 1;
    rate +=  getExistingTourBatta(data) * totalDays;
    
    return rate;
}

// DISTANCE OFFSET PER 7 DAYS
export function getAdditionalExistingTourDayBasedDistance(data, hasCoordinates){
    // Manual distance
    if(!hasCoordinates){
        return 0;
    }
    
    return data.kmOffsetFor7Day;
}

// TOTAL DISTANCE AFTER 7 DAYS OFFSET
export function getExistingTourDrivingKm(data, hasCoordinates){
    let totalKm = Number.parseFloat(data?.distance);
    totalKm += getAdditionalExistingTourDayBasedDistance(data, hasCoordinates);

    return totalKm;
}

// MINIMUM KM PER DAY TO COVER
export function getExistingTourMinimumKm(data){
    return data.minKmPerDay;
}

// MINIMUM KM PER TOUR TO COVER
export function getExistingTourMinimumKmToCover(data){
    let kmPerDay = getExistingTourMinimumKm(data);
    return data?.days * kmPerDay;
}

// FINAL DISTANCE
export function getExistingTourFinalKm(data, hasCoordinates){
    const totalKm = getExistingTourDrivingKm(data, hasCoordinates);
    const minKm = getExistingTourMinimumKmToCover(data);

    if(totalKm < minKm){
        return minKm;
    }

    return totalKm;
}

// ROUND OF THE FINAL KM
export function getExistingTourRoundedKmOffset(data, hasCoordinates){
    let roundingKmDigit = getExistingTourFinalKm(data, hasCoordinates);

    if(roundingKmDigit > 100){
        roundingKmDigit = roundingKmDigit % 100;
    }

    let roundKm = 0;

    if(roundingKmDigit <= 20){
        roundKm = -roundingKmDigit;
    }
    else if(roundingKmDigit <= 80){
        roundKm = 50 - roundingKmDigit;
    }
    else{
        roundKm = 100 - roundingKmDigit;
    }

    return roundKm;
}
export function getExistingTourRoundedKm(data, hasCoordinates){
    let finalKm = getExistingTourFinalKm(data, hasCoordinates);

    finalKm += getExistingTourRoundedKmOffset(data, hasCoordinates);

    return finalKm;
}

// USD CONVERSION RATE
export function getExistingTourUSDConversionRate(data){
    return data.usdConversion;
}

// ADDITIONAL KM
export function getExistingTourAdditionalKm(data, hasCoordinates){
    return (getExistingTourFinalKm(data, hasCoordinates) - getExistingTourDrivingKm(data, hasCoordinates)).toFixed(2);
}

// ACTUAL RATE WITHOUT BATTA
export function getExistingTourActualRateWithoutBatta(data, hasCoordinates){
    let rate = getExistingTourRoundedKm(data, hasCoordinates) * Number.parseFloat(data?.perKm);
    return numberWithCommas(rate.toFixed(2));
}

// GET TOTAL
export function getExistingTourTotalRateLKR(data, hasCoordinates){
    let rate = getExistingTourRoundedKm(data, hasCoordinates) * Number.parseFloat(data?.perKm);

    rate += getExistingTourTotalBatta(data);

    const usdConversion = getExistingTourUSDConversionRate(data);
    rate += getSeasonRate(data, usdConversion) + getMarginLKR(data, usdConversion);

    return rate;
}
//#endregion

//#region SHARED
// SEASON TYPE
export function getSeasonType(data){
    const month = data?.month;
    let season = "";

    for(let i = 0; i < MONTH.length; i++){
        if(MONTH[i].value === month){
            season = MONTH[i].season;
            break;
        }
    }

    return season;   
}

// SEASON RATE
export function getSeasonRate(data, usdConversion){
    const season = getSeasonType(data);

    if(season === "Off"){
        return 0;
    }

    const days = data?.days ?? 1;
        
    return days * usdConversion * 5;   
}

// GET MARGIN USD
export function getMarginUSDRate(data){
    let vehicleID;

    for(let i = 0; i < VEHICLE.length; i++){
        if(VEHICLE[i].value === data?.vehicle){
            vehicleID = VEHICLE[i].id;
        }
    }

    const days = data?.days;

    let margin = 0;

    for(let i = 0; i < MARGIN.length; i++){
        if(MARGIN[i].vehicle === vehicleID){
            for(let j = 0; j < MARGIN[i].breakdown.length; j++){
                if(days >= MARGIN[i].breakdown[j].minDay && days <= MARGIN[i].breakdown[j].maxDay){
                    const season = getSeasonType(data);

                    margin = season === "Off" ? MARGIN[i].breakdown[j].seasonal_rate.off : MARGIN[i].breakdown[j].seasonal_rate.peak;

                    break;
                }
            }
        }
    }

    return margin;   
}

// GET MARGIN LKR
export function getMarginLKR(data, usdConversionRate){
    return getMarginUSDRate(data) * usdConversionRate;
}
//#endregion